'use client';

/** Current → Proposed diff for edit_contact / edit_company approvals. */
export function EditDiffPreview({ current, proposed }: { current: unknown; proposed: unknown }) {
  return (
    <div className="mb-3 space-y-2">
      <div className="grid grid-cols-2 gap-2 text-xs">
        <div className="bg-red-50 dark:bg-red-900/20 p-2 rounded border border-red-200 dark:border-red-800">
          <p className="font-semibold text-red-900 dark:text-red-100 mb-1">Current</p>
          <pre className="overflow-auto text-xs">{JSON.stringify(current, null, 2)}</pre>
        </div>
        <div className="bg-green-50 dark:bg-green-900/20 p-2 rounded border border-green-200 dark:border-green-800">
          <p className="font-semibold text-green-900 dark:text-green-100 mb-1">Proposed</p>
          <pre className="overflow-auto text-xs">{JSON.stringify(proposed, null, 2)}</pre>
        </div>
      </div>
    </div>
  );
}
